import { motion } from "framer-motion";
import { MANIFESTO } from "../../lib/site";

export const Manifesto = () => {
  return (
    <section id="manifesto" className="relative border-t border-white/10 bg-background py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="sticky top-28">
              <div className="mb-4 flex items-center gap-3 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-primary">
                <span className="inline-block h-2 w-2 bg-primary" /> Why Maddox
              </div>
              <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight md:text-6xl">
                Four things <br /> we never <br />
                <span className="text-stroke-primary">compromise.</span>
              </h2>
            </div>
          </div>

          <div className="md:col-span-8">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="group grid grid-cols-[auto_1fr] gap-6 border-b border-white/10 py-8 transition-colors hover:bg-white/[0.02] md:gap-10 md:py-10"
              >
                <span className="font-mono-tech text-sm text-primary md:text-base">{m.n}</span>
                <div>
                  <h3 className="font-display text-3xl uppercase tracking-tight transition-colors group-hover:text-primary md:text-4xl">
                    {m.title}
                  </h3>
                  <p className="mt-3 max-w-xl text-sm text-muted-foreground md:text-base">
                    {m.body}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
